import React from 'react';
import { createRoot } from 'react-dom/client';
import FloorPlan from './floor-plan/FloorPlan';
const rootEl = document.getElementById('floor-plan');
if (rootEl) {
    const root = createRoot(rootEl);
    root.render(React.createElement(FloorPlan, null));
}
